module.exports = __webpack_public_path__ + "static/img/knives12.e2db31a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/knives12.jpg
// module id = Nfiy
// module chunks = 0